import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClinicRoutingModule } from './clinic-routing.module';
import { ClinicViewComponent } from './pages/clinic-view/clinic-view.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../shared/shared.module';
import { ClinicViewBodyComponent } from './components/clinic-view-body/clinic-view-body.component';
import { SocialNetworksComponent } from './components/social-networks/social-networks.component';

@NgModule({
    declarations: [
        ClinicViewComponent,
        ClinicViewComponent,
        ClinicViewBodyComponent,
        SocialNetworksComponent,
    ],
    imports: [CommonModule, ClinicRoutingModule, IonicModule, SharedModule],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class ClinicModule {}
